import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import Alert from 'UiKit/alert';

import Head from 'View/reschedule/section/head';
import Filter from 'View/reschedule/section/filter';
import Table from 'View/reschedule/section/table';
import Tab from 'View/reschedule/section/tab';
import RequestApprovalProvider, { useRequestApprovalState } from 'View/reschedule/state';

import styles from './styles.module.css';

const RequestApproval = () => {
  const { state, updateState } = useRequestApprovalState();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  useEffect(() => {
    if (tab) updateState({ selectedTab: tab });
    else updateState({ selectedTab: state?.selectedTab });
  }, []); // eslint-disable-line

  return (
    <Box className={styles['request-approval__container']}>
      <Head />
      <Tab />
      <Filter />
      <Alert {...state?.alertProps} />
      <Table />
    </Box>
  );
};

const RequestApprovalContainer = () => <RequestApprovalProvider children={<RequestApproval />} />;

export default RequestApprovalContainer;
